<template>
  <div class="impostazioni">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Impostazioni</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="codice" v-model="formData.anagrafica.codice" type="text" :state="state.codice" placeholder="Codice dell'installatore" disabled/><label for="codice">* Codice</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="8">
          <b-form-input class="slide-up" id="denominazione" v-model="formData.anagrafica.denominazione" type="text" :state="state.denominazione" placeholder="Denominazione dell'installatore"/><label for="denominazione">* Denominazione</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cf" v-model="formData.anagrafica.cf" type="text" :state="state.cf" placeholder="Codice fiscale dell'installatore" /><label for="cf">Codice Fiscale</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="piva" v-model="formData.anagrafica.piva" type="text" :state="state.piva" placeholder="Partita IVA dell'installatore" /><label for="piva">* Partita IVA</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>RESIDENZA</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row v-bind:class="{'hide_class': !flag.maps}">
        <b-col cols="12" offset-md="1" md="10">
          <b-button size="sm" style="float: right; margin-bottom: 15px" v-on:click="toggleAddress()">Inserisci l'indirizzo manualmente <font-awesome-icon icon="edit" /></b-button>
          <b-form-input id="search_box" type="search" placeholder="Seleziona il tuo indirizzo" :state="state.search_address" autocomplete="off"></b-form-input>
          <div id="ubicazione_map"></div>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row v-bind:class="{'hide_class': flag.maps}">
        <b-col>
          <b-row>
            <b-col>
              <b-button variant="primary" size="sm" style="float: right; margin-bottom: 15px" v-on:click="toggleAddress()">Utilizza la mappa <font-awesome-icon icon="map-marked-alt" /></b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="9">
              <b-form-input class="slide-up" id="via" v-model="formData.anagrafica.via" type="text" :state="state.via" placeholder="Via dell'installatore" /><label for="via">Via *</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-input class="slide-up" id="civico" v-model="formData.anagrafica.civico" type="text" :state="state.civico" placeholder="Civico dell'installatore"/><label for="civico">Civico *</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="comune" v-model="formData.anagrafica.comune" type="text" :state="state.comune" placeholder="Comune dell'installatore" /><label for="comune">Comune *</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="cap" v-model="formData.anagrafica.cap" type="text" :state="state.cap" placeholder="CAP dell'installatore"/><label for="cap">CAP *</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="provincia" v-model="formData.anagrafica.provincia" type="text" :state="state.provincia" placeholder="Provincia dell'installatore" /><label for="provincia">Provincia *</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="nazione" v-model="formData.anagrafica.nazione" type="text" :state="state.nazione" placeholder="Nazione dell'installatore"/><label for="nazione">Nazione *</label>
              <br>
              <br>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>ALTRE INFORMAZIONI</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="website" v-model="formData.anagrafica.website" type="text" :state="state.website" placeholder="Sito web dell'installatore" /><label for="website">Sito web</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="email" v-model="formData.user.email" type="text" :state="state.email" placeholder="Email dell'installatore" disabled/><label for="email">Email *</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="cellulare" v-model="formData.anagrafica.cellulare" type="text" :state="state.cellulare" placeholder="Numero di cellulare dell'installatore" /><label for="cellulare">Cellulare</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="telefono" v-model="formData.anagrafica.telefono" type="text" :state="state.telefono" placeholder="Numero del telefono fisso dell'installatore" /><label for="telefono">Telefono fisso</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="fax" v-model="formData.anagrafica.fax" type="text" :state="state.fax" placeholder="Numero del Fax dell'installatore" /><label for="fax">Fax</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="formData.anagrafica.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text" v-if="stato.installatore && !userData.impersona.stato">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>LOGO</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row v-if="stato.installatore && !userData.impersona.stato">
        <b-col cols="12" md="10">
          <file-pond ref="logo" label-idle="* Trascina o seleziona il logo da caricare" allow-multiple="false" max-files="1"/>
          <p style="color: grey">La dimensione massima del logo è di 25mb, deve essere rettangolare con proporzioni altezza/base 1 a 3. I formati accettati sono: jpeg, png, bmp.</p>
          <p style="color: grey">Il logo deve avere le proporzioni e formato indicate, se non le avesse occorre salvarlo in una immagine con un formato accettato con quelle proporzioni</p>
          <br>
        </b-col>
        <b-col cols="12" md="2">        
          <b-button variant="success" size="lg" v-on:click="downloadLogo()"><font-awesome-icon icon="file-download" /> Scarica</b-button>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text" v-if="stato.installatore && !userData.impersona.stato">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>DURC</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row v-if="stato.installatore && !userData.impersona.stato">
        <b-col cols="12" md="6">
          <file-pond ref="durc" label-idle="* Trascina o seleziona il DURC da caricare" allow-multiple="false" max-files="1"/>
          <br>
        </b-col>
        <b-col cols="12" md="2">        
          <b-button variant="success" size="lg" v-on:click="downloadDURC()"><font-awesome-icon icon="file-download" /> Scarica</b-button>
          <br>
          <br>
        </b-col>
        <b-col md="4" cols="12">
          <VueCtkDateTimePicker v-model="formData.anagrafica.durc_scadenza" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
            <b-form-input v-model="formData.anagrafica.durc_scadenza" class="slide-up fix_datetime_picker" id="durc_scadenza" :state="state.durc_scadenza" type="text" placeholder="Data di scadenza del DURC"/><label for="durc_scadenza">Scadenza</label>
          </VueCtkDateTimePicker>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text" v-if="stato.installatore && !userData.impersona.stato">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>VISURA CAMERALE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row v-if="stato.installatore && !userData.impersona.stato">
        <b-col cols="12" md="6">
          <file-pond ref="visura_camerale" label-idle="* Trascina o seleziona la visura camerale da caricare" allow-multiple="false" max-files="1"/>
          <br>
        </b-col>
        <b-col cols="12" md="2">        
          <b-button variant="success" size="lg" v-on:click="downloadVisura()"><font-awesome-icon icon="file-download" /> Scarica</b-button>
          <br>
          <br>
        </b-col>
        <b-col md="4" cols="12">
          <VueCtkDateTimePicker v-model="formData.anagrafica.visura_camerale_scadenza" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
            <b-form-input v-model="formData.anagrafica.visura_camerale_scadenza" class="slide-up fix_datetime_picker" id="visura_camerale_scadenza" :state="state.visura_camerale_scadenza" type="text" placeholder="Data di scadenza della Visura Camerale"/><label for="visura_camerale_scadenza">Scadenza</label>
          </VueCtkDateTimePicker>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" offset-md="8">        
          <b-button variant="success" size="lg" v-on:click="updateInstallatore()"><font-awesome-icon icon="marker" /> Aggiorna Profilo</b-button>
        </b-col>
      </b-row>

      <br>
      <br>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>CAMBIA PASSWORD</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" offset-md="3" md="6">
          <b-form-input class="slide-up" id="oldPass" v-model="formData.password.oldPass" type="password" :state="state.oldPass" placeholder="Password attuale"/><label for="oldPass">* Password Attuale</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="newPass1" v-model="formData.password.newPass1" type="password" :state="state.newPass1" placeholder="Nuova password"/><label for="newPass1">* Nuova Password</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="newPass2" v-model="formData.password.newPass2" type="password" :state="state.newPass2" placeholder="Digita di nuovo la nuova password"/><label for="newPass2">* Ripeti Nuova Password</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" offset-md="8">        
          <b-button variant="success" size="lg" v-on:click="cambiaPassword()"><font-awesome-icon icon="marker" /> Cambia Password</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import { mapGetters } from 'vuex'
import { globalConf } from '../config.global'

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview)

var map
var markers
export default {
  name: 'impostazioni',
  data() {
    return {
      state: {
        oldPass: null,
        newPass1: null,
        newPass2: null,
        codice: null,
        denominazione: null,
        cf: null,
        piva: null,
        via: '',
        civico: '',
        nazione: '',
        provincia: '',
        comune: '',
        cap: '',
        website: null,
        cellulare: null,
        telefono: null,
        fax: null,
        note: null,
        email: null,
        search_address: null,
        durc_scadenza: null,
        visura_camerale_scadenza: null
      },
      formData: {
        anagrafica: {
          codice: '',
          denominazione: '',
          cf: '',
          piva: '',
          via: '',
          civico: '',
          nazione: '',
          provincia: '',
          comune: '',
          cap: '',
          website: '',
          cellulare: '',
          telefono: '',
          fax: '',
          note: '',
          durc_scadenza: null,
          visura_camerale_scadenza: null
        }, 
        user: {
          email: ''
        },
        password: {
          oldPass: '',
          newPass1: '',
          newPass2: ''
        }
      },
      flag: {
        maps: true
      }
    }
  },
  components: {
    FilePond
  },
  created: function(){
    this.loadUser()
  },
  methods: {
    cambiaPassword(){
      Vue.http.post('user/reset', this.formData.password, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Password cambiata con successo!',
            type: 'success'
          })
          this.$router.push('/')
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la modifica!',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },

    loadMap(){
      map = new google.maps.Map(document.getElementById('ubicazione_map'), {
        center: {lat: 42.504154, lng: 12.646361},
        streetViewControl: false,
        zoom: 6
      })

      var input = document.getElementById('search_box')
      var searchBox = new google.maps.places.SearchBox(input)
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

      document.getElementById('search_box').value = this.formData.anagrafica.via+", "+this.formData.anagrafica.civico+", "+this.formData.anagrafica.cap+
                      " "+this.formData.anagrafica.comune+" "+this.formData.anagrafica.provincia+", "+this.formData.anagrafica.nazione

      var localthis = this
      
      var service = new google.maps.places.PlacesService(map);
      
      var request = {
        query: document.getElementById('search_box').value,
        fields: ['formatted_address', 'geometry', 'html_attributions', 'icon', 'id', 'name', 'place_id', 'plus_code', 'reference', 'types'],
      }

      service.findPlaceFromQuery(request, function(results, status) {
        localthis.setMap(results)
      })

      map.addListener('bounds_changed', function() {
        searchBox.setBounds(map.getBounds())
      })

      markers = []

      searchBox.addListener('places_changed', function() {
        var places = searchBox.getPlaces()

        localthis.setMap(places)
      })
    },
    setMap(places){
      this.state.search_address = null
      var check_msg = this.checkAddress(places)
      if(check_msg.length > 0){
        Vue.notify({
          group: 'global',
          title: 'Ubicazione errata!',
          text: check_msg[1],
          type: check_msg[0]
        })

        if(check_msg[0] == "error")
          this.state.search_address = false

        places = []
      }else{
        this.setByPlace(places[0].formatted_address)
      }

      markers.forEach(function(marker) {
        marker.setMap(null)
      })
      markers = []

      var bounds = new google.maps.LatLngBounds()
      places.forEach(function(place) {
        if (!place.geometry) {
          console.log("Returned place contains no geometry")
          return
        }
        var icon = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25)
        }

        markers.push(new google.maps.Marker({
          map: map,
          icon: icon,
          title: place.name,
          position: place.geometry.location
        }))

        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport)
        } else {
          bounds.extend(place.geometry.location)
        }
      })
      map.fitBounds(bounds)
    },
    checkAddress(places, first_load = false){
      if(!places || places.length == 0 || places.length > 1){
        return ['info', "Non è stato possibile trovare il punto esatto dell'indirizzo fornito!"]
      }

      var luogo = places[0].formatted_address

      document.getElementById('search_box').value = luogo
      
      var campi = luogo.split(",")

      if(campi.length != 4){
        return ["error", "L'indirizzo inserito non è completo di tutte le informazioni necessarie!"]
      }

      if(campi[1].trim().split(" ").length != 1){
        return ["error", "Assicurati di aver selezionato correttamente la tua ubicazione e di aver selezionato un punto bel preciso!"]
      }

      if(!(campi[3].trim() == "Italia" || campi[3].trim() == "Italy")){
        return ["error", "Attualmente sono supportati solo indirizzi italiani! Per qualsiasi dubbio contattare l'assistenza."]
      }

      var sub_campi = campi[2].trim().split(" ")

      if(sub_campi.length < 3)
        return ["error", "L'indirizzo inserito non è valido!"]

      if(isNaN(Number.parseInt(sub_campi[0].trim())))
        return ["error", "L'indirizzo inserito non contiene un CAP valido! Riprovare."]

      if(sub_campi[sub_campi.length - 1].trim().length != 2)
        return ["error", "La provincia inserita non è valida!"]

      return []
    },
    toggleAddress(){
      this.formData.anagrafica.via = ''
      this.formData.anagrafica.civico = ''
      this.formData.anagrafica.nazione = ''
      this.formData.anagrafica.cap = ''
      this.formData.anagrafica.provincia = ''
      this.formData.anagrafica.comune = ''

      document.getElementById('search_box').value = ""

      this.flag.maps = !this.flag.maps
    },
    checkManualAddress(){
      var msg = ""
      if(!(this.formData.anagrafica.via && this.formData.anagrafica.via.length > 0 && this.formData.anagrafica.via.length <= 200)){
        this.state.via = false
        if(msg == "") msg = "Il campo Via non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 200)!" 
      }

      if(!(this.formData.anagrafica.civico && this.formData.anagrafica.civico.length > 0 && this.formData.anagrafica.civico.length <= 10)){
        this.state.civico = false
        if(msg == "") msg = "Il campo Civico non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 10)!" 
      }
      
      if(!(this.formData.anagrafica.comune && this.formData.anagrafica.comune.length > 0 && this.formData.anagrafica.comune.length <= 200)){
        this.state.comune = false
        if(msg == "") msg = "Il campo Comune non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 200)!" 
      }
      
      if(!(this.formData.anagrafica.cap && this.formData.anagrafica.cap.length > 0 && this.formData.anagrafica.cap.length <= 10)){
        this.state.cap = false
        if(msg == "") msg = "Il campo cap non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 10)!" 
      }
      
      if(!(this.formData.anagrafica.provincia && this.formData.anagrafica.provincia.length > 0 && this.formData.anagrafica.provincia.length <= 200)){
        this.state.provincia = false
        if(msg == "") msg = "Il campo Provincia non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 200)!" 
      }

      if(!(this.formData.anagrafica.nazione && this.formData.anagrafica.nazione.length > 0 && this.formData.anagrafica.nazione.length <= 100)){
        this.state.nazione = false
        if(msg == "") msg = "Il campo Nazione non è stato correttamente riempito o ha superato il limite massimo di caratteri (max 100)!" 
      }

      return msg
    },
    setByPlace(places){
      console.log(places)

      document.getElementById('search_box').value = places

      var campi = places.split(",")

      this.formData.anagrafica.via = campi[0]
      this.formData.anagrafica.civico = campi[1]
      this.formData.anagrafica.nazione = campi[3] //TODO: se cerco indirizzo fuori italia ho problemi nella formattazione dell'indirizzo

      var sub_campi = campi[2].split(" ")

      this.formData.anagrafica.cap = sub_campi[1]
      this.formData.anagrafica.provincia = sub_campi[sub_campi.length - 1]
      this.formData.anagrafica.comune = sub_campi.slice(2, sub_campi.length - 1).join(" ")
    },
    updateInstallatore(){
      for(var i=0; i<Object.keys(this.state).length; i++){
        this.state[Object.keys(this.state)[i]] = null
      }

      var check_msg = this.checkManualAddress()
      if(check_msg != ""){
        Vue.notify({
          group: 'global',
          title: 'Ubicazione errata!',
          text: check_msg,
          type: 'error'
        })
        this.state.search_address = false
        return
      }

      var user_t = JSON.parse(JSON.stringify(this.formData.user))
      var anagrafica_t = JSON.parse(JSON.stringify(this.formData.anagrafica))

      if(!this.flag.maps)
        anagrafica_t.nazione = "M_"+this.formData.anagrafica.nazione

      var form = new FormData()
      form.append("body", JSON.stringify({user: user_t, anagrafica: anagrafica_t}))
      
      if(this.stato.installatore && !this.userData.impersona.stato){
        if(this.$refs.logo.getFiles().length == 1)
          form.append('logo', this.$refs.logo.getFiles()[0].file, this.$refs.logo.getFiles()[0].file.name)

        if(this.$refs.durc.getFiles().length == 1)
          form.append('durc', this.$refs.durc.getFiles()[0].file, this.$refs.durc.getFiles()[0].file.name)

        if(this.$refs.visura_camerale.getFiles().length == 1)
          form.append('visura_camerale', this.$refs.visura_camerale.getFiles()[0].file, this.$refs.visura_camerale.getFiles()[0].file.name)
      }
      Vue.http.post('user/update', form, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Profilo aggiornato con successo!',
            type: 'success'
          })
          this.$router.push('/')
        }else{
          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la modifica!',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },
    loadUser(){
      Vue.http.post('user/load', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.formData.user = response.body.data.user
            this.formData.anagrafica = response.body.data.anagrafica

            if(this.formData.anagrafica.nazione.slice(0, 2) == "M_"){
              this.formData.anagrafica.nazione = this.formData.anagrafica.nazione.slice(2)
              this.flag.maps = false
            }

            Vue.loadScript("https://maps.googleapis.com/maps/api/js?key="+globalConf.gmaps+"&libraries=places")
            .then(() => {
              this.loadMap()
            })
            .catch((e) => {
              console.log("Errore durante il caricamento di Google Maps!")
            })
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    },
    downloadLogo(){
      window.open(Vue.prototype.$hostlink+"user/download/logo")
    },
    downloadDURC(){
      window.open(Vue.prototype.$hostlink+"user/download/durc")
    },
    downloadVisura(){
      window.open(Vue.prototype.$hostlink+"user/download/visura")
    }
  },
  computed: {
    ...mapGetters(['stato', 'userData'])
  }
}
</script>

<style scoped>
#search_box{
  width: 60%;
  margin-top: 10px;
  margin-left: 20px;
}

#ubicazione_map{
  width: 100%;
  height: 400px;
  border-radius: 4px;

  -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
}

#codice{
  text-indent: 90px;
}

#denominazione{
  text-indent: 150px;
}

#cf{
  text-indent: 140px;
}

#piva{
  text-indent: 110px;
}

#website{
  text-indent: 95px;
}

#cellulare{
  text-indent: 95px;
}

#telefono{
  text-indent: 130px;
}

#fax{
  text-indent: 60px;
}

#note{
  text-indent: 70px;
  line-height: 1.8;
}

#email{
  text-indent: 85px;
}

#durc_scadenza{
  text-indent: 90px;
}

#visura_camerale_scadenza{
  text-indent: 90px;
}

#oldPass{
  text-indent: 170px;
}

#newPass1{
  text-indent: 165px;
}

#newPass2{
  text-indent: 210px;
}

#via{
  text-indent: 65px;
}

#civico{
  text-indent: 85px;
}

#comune{
  text-indent: 105px;
}

#cap{
  text-indent: 75px;
}

#provincia{
  text-indent: 110px;
}

#nazione{
  text-indent: 100px;
}
</style>
